<template>
  <div class="login" style="height: calc(100vh);width: 100%;">
    <img :src="$store.state.appInfo.background" class="absolute"
         style="z-index: -1;min-width: 440px;min-height:600px;width: calc(100vw);height: calc(100vh);"/>
    <div style="height: 100px;width: 100%;text-align: center;padding: 60px 0;">
      <template v-if="!Tool.isNull($store.state.appInfo)">
        <el-image :src="$store.state.appInfo.logoUrl" style="width: 70px;height: 70px;vertical-align: middle;border-radius: 4px;"></el-image>
        <!--            <div style="font-size: 28px;color: #333333;margin-top: 16px;">{{$store.state.appInfo.organizationName}}</div>-->
        <div style="font-size: 28px;color: #333333;margin-top: 16px;display: inline-block">湖北音协在线会员中心申报系统</div>
      </template>
    </div>
    <div class="text-center">
      <div class="inline-block" style="width: 440px;height: 400px;background-color: rgba(255,255,255,0.9);border-radius: 16px;box-shadow:0px 8px 24px rgba(5,0,85,0.08);">
        <div style="padding: 50px 50px;height: 300px;">
          <div style="font-size: 24px;margin-bottom: 20px;">登录</div>
          <el-form v-if="form" :model="form" ref="form" label-width="0px" :hide-required-asterisk="true">
            <div>
              <div style="text-align: right;margin-bottom: 10px">
                <span @click="$router.push({path:'./register'})" style="color: #4E45EE;cursor: pointer">注册</span>
              </div>
              <el-form-item label="" prop="userAccount" label-width="0px" :rules="[$validate.string(30)]">
                <el-input v-model="form.userAccount" :maxlength="30" placeholder="请输入账号" clearable></el-input>
              </el-form-item>
              <el-form-item v-if="['loginByPass'].indexOf(type)>-1" label="" prop="password" label-width="0px" :rules="[$validate.password(6,20)]">
                <el-input v-model="form.password" type="password" :maxlength="20" placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item v-if="['loginByVcode','resetPass'].indexOf(type)>-1" label="" prop="authCode" label-width="0px" :rules="[$validate.vcode(6)]">
                <el-input v-model="form.authCode" @input="e=>form.authCode=Tool.checkNumber(e)" :maxlength="6" placeholder="请输入验证码"></el-input>
                <div class="absolute text-right flex-middle" style="right: 10px;margin-top: -35px;">
                  <div class="inline-block" style="border-left: solid 1px #cccccc;height: 25px;width: 10px;"></div>
                  <el-button v-if="time==-1" style="margin-right: 0px;color: #4E45EE;" type="text" @click.stop="sendVcode">发送验证码</el-button>
                  <el-button v-else-if="time==0" style="margin-right: 0px;color: #4E45EE;" type="text" @click.stop="sendVcode">重新发送</el-button>
                  <span v-else style="margin-right: 0px;color: #606266;">重新发送({{time}}S)</span>
                </div>
              </el-form-item>
              <el-form-item v-if="['resetPass'].indexOf(type)>-1" label="新密码" prop="newPass" :rules="[$validate.password(6,20)]">
                <el-input v-model="form.newPass" type="password" :maxlength="20" placeholder="请输入新密码"></el-input>
              </el-form-item>
              <!--              <div class="text-center">-->
              <!--                <div class="inline-block">-->
              <!--                  <DragVerify :width="340" :height="40" progress-bar-bg="#23C266" text-size="20px" background="#E5E5E5" handler-icon="icon icon_arrow-right" success-icon="icon icon_arrow-right"-->
              <!--                              text="请将滑块拖动到右侧" success-text="验证通过" @passcallback="checkInput(true)" color="#ffffff">-->
              <!--                  </DragVerify>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
          </el-form>
          <div v-if="type=='resetPass'" class="text-right" style="margin-top: 20px;">
            <el-button type="text" @click="type='loginByPass'"><i class="icon icon_back"></i> 返回登录</el-button>
            <el-button :disabled="disabled" size="medium" type="primary" @click="submit()">重置密码</el-button>
          </div>
          <div v-else class="text-center" style="margin-top: 20px;">
            <!--<el-button type="text" @click="type='resetPass'">忘记密码?</el-button>-->
            <el-button :disabled="!form.userAccount || !form.authCode" size="medium" type="primary" @click="submit()" style="width: 340px;">登录</el-button>
          </div>
          <div class="text-center" style="margin-top: 20px;">
            <span @click="$router.push({path:'./login-pwd'})" style="color: #4E45EE;cursor: pointer">密码登录</span>
          </div>
        </div>
      </div>
      <div v-if="$store.state.appInfo.phone" style="margin-top: 20px;color: #333333;">
        <i class="icon icon_phone"></i>
        {{$store.state.appInfo.phone}}
      </div>
    </div>
    <div class="text-center fixed" style="color: #666666;font-size: 12px;bottom: 10px;width: 100%;">
      {{$store.state.appInfo.bottomDesc}}
    </div>
  </div>
</template>
<script>
// import DragVerify from 'vue-drag-verify'

export default {
  name: 'login',
  props: [],
  data () {
    return {
      form: {
        userAccount: '',
        authCode: '',
        loginType: 1
      },
      tabList: [{ name: 'loginByPass', label: '密码登录' }, { name: 'loginByVcode', label: '验证码登录' }],
      type: 'loginByVcode',
      time: -1,
      interval: 0,
      disabled: true
    }
  },
  created () {
    this.$store.commit('setCurrentUserInfo', {})
  },
  async mounted () {
  },
  async beforeDestroy () {
    clearInterval(this.interval)
  },
  computed: {},
  watch: {
    form: {
      handler: function () {
        this.checkInput()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    checkInput (passOK = false) {
      if (passOK) {
        this.form.passOK = passOK
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    async submit () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        let userInfo = await this.$HTTP.ApiUser.login(this.form)
        this.$store.commit('setCurrentUserInfo', userInfo)
        // this.Tool.setStorage('token', userInfo.token)
        this.$router.push('/vip/apply')
      }
    },
    async sendVcode () {
      let isOK = this.form.userAccount
      // await this.Tool.checkForm(this.$refs['form'], ['userAccount'])
      if (isOK) {
        if (isOK.indexOf("@") != -1) {
          let params = {
            email: this.form.userAccount,
            smsType: 2
          }
          let vcode = await this.$HTTP.ApiUser.sendEmailcode(params)
          if (vcode && /^\d{6}$/.test(vcode)) {
            this.form.authCode = vcode
            this.$refs['form'].clearValidate()
          }
          this.$message({ type: 'success', message: '发送验证码成功' })
          this.time = 60
          this.interval = setInterval(() => {
            if (this.time > 0) {
              this.time--
            } else {
              clearInterval(this.interval)
            }
          }, 1000)
        } else {
          let params = {
            phoneNumber: this.form.userAccount,
            smsType: 2
          }
          let vcode = await this.$HTTP.ApiUser.sendVcode(params)
          if (vcode && /^\d{6}$/.test(vcode)) {
            this.form.authCode = vcode
            this.$refs['form'].clearValidate()
          }
          this.$message({ type: 'success', message: '发送验证码成功' })
          this.time = 60
          this.interval = setInterval(() => {
            if (this.time > 0) {
              this.time--
            } else {
              clearInterval(this.interval)
            }
          }, 1000)
        }
      } else {
        await this.Tool.checkForm(this.$refs['form'], ['userAccount'])
      }
    }
  }
}
</script>
<style>
  .dv_text {
    font-size: 14px !important;
  }

  .dv_handler {
    margin-top: 2px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    border-radius: 19px !important;
    width: 60px !important;
    height: 36px !important;
    border: none !important;
  }

  .dv_handler .icon {
    color: #23C266 !important;
  }

  .login .el-button.el-button--primary.is-disabled {
    background-color: rgba(78, 69, 238, 0.3) !important;
    border-color: rgba(78, 69, 238, 0.3) !important;
  }

  .login .el-button.el-button--primary {
    background-color: rgba(78, 69, 238, 1) !important;
    border-color: rgba(78, 69, 238, 1) !important;
  }
</style>
